__turbopack_export_value__({
  "body-logo-18": "CookieNotice-module-scss-module__SaKnYW__body-logo-18",
  "body-text-12": "CookieNotice-module-scss-module__SaKnYW__body-text-12",
  "body-text-14": "CookieNotice-module-scss-module__SaKnYW__body-text-14",
  "body-text-16": "CookieNotice-module-scss-module__SaKnYW__body-text-16",
  "body-text-18": "CookieNotice-module-scss-module__SaKnYW__body-text-18",
  "body-text-20": "CookieNotice-module-scss-module__SaKnYW__body-text-20",
  "body-text-24": "CookieNotice-module-scss-module__SaKnYW__body-text-24",
  "body-text-24-2": "CookieNotice-module-scss-module__SaKnYW__body-text-24-2",
  "body-text-heading-2": "CookieNotice-module-scss-module__SaKnYW__body-text-heading-2",
  "body-text-heading-3": "CookieNotice-module-scss-module__SaKnYW__body-text-heading-3",
  "body-text-medium-14": "CookieNotice-module-scss-module__SaKnYW__body-text-medium-14",
  "body-text-medium-16": "CookieNotice-module-scss-module__SaKnYW__body-text-medium-16",
  "body-text-medium-18": "CookieNotice-module-scss-module__SaKnYW__body-text-medium-18",
  "body-text-medium2-18": "CookieNotice-module-scss-module__SaKnYW__body-text-medium2-18",
  "body-text2-14": "CookieNotice-module-scss-module__SaKnYW__body-text2-14",
  "body-text2-16": "CookieNotice-module-scss-module__SaKnYW__body-text2-16",
  "button-primary-text": "CookieNotice-module-scss-module__SaKnYW__button-primary-text",
  "button-text": "CookieNotice-module-scss-module__SaKnYW__button-text",
  "button2-text": "CookieNotice-module-scss-module__SaKnYW__button2-text",
  "card-shadow": "CookieNotice-module-scss-module__SaKnYW__card-shadow",
  "effect-menu": "CookieNotice-module-scss-module__SaKnYW__effect-menu",
  "header-1": "CookieNotice-module-scss-module__SaKnYW__header-1",
  "main-container": "CookieNotice-module-scss-module__SaKnYW__main-container",
  "main-footer-container": "CookieNotice-module-scss-module__SaKnYW__main-footer-container",
  "main-header-container": "CookieNotice-module-scss-module__SaKnYW__main-header-container",
  "txt-12-bold": "CookieNotice-module-scss-module__SaKnYW__txt-12-bold",
  "txt-14-bold": "CookieNotice-module-scss-module__SaKnYW__txt-14-bold",
  "txt-14-bold-caps": "CookieNotice-module-scss-module__SaKnYW__txt-14-bold-caps",
  "txt-14-med": "CookieNotice-module-scss-module__SaKnYW__txt-14-med",
  "txt-16-bold": "CookieNotice-module-scss-module__SaKnYW__txt-16-bold",
  "txt-16-med": "CookieNotice-module-scss-module__SaKnYW__txt-16-med",
  "txt-18-bold": "CookieNotice-module-scss-module__SaKnYW__txt-18-bold",
  "txt-18-medium": "CookieNotice-module-scss-module__SaKnYW__txt-18-medium",
  "txt-18-medium-24": "CookieNotice-module-scss-module__SaKnYW__txt-18-medium-24",
  "txt-24-semi": "CookieNotice-module-scss-module__SaKnYW__txt-24-semi",
  "wrapper": "CookieNotice-module-scss-module__SaKnYW__wrapper",
  "wrapper__subtitle": "CookieNotice-module-scss-module__SaKnYW__wrapper__subtitle",
  "wrapper__title": "CookieNotice-module-scss-module__SaKnYW__wrapper__title",
});
